import React from 'react';
import { Card } from '@/components/ui/card';
import { History } from 'lucide-react';
import { formatTs } from './api';

const ACTION_COLORS = {
  export: 'bg-emerald-100 text-emerald-800',
  import_commit: 'bg-amber-100 text-amber-800',
  import_validate: 'bg-slate-100 text-slate-800',
};

export default function AuditTable({ rows, loading }) {
  return (
    <Card className="p-6" data-testid="audit-card">
      <h2 className="text-lg font-bold uppercase mb-4 flex items-center gap-2">
        <History className="w-5 h-5 text-emerald-600" /> Recent Activity
      </h2>
      {loading ? (
        <p className="text-sm text-muted-foreground">Loading...</p>
      ) : rows.length === 0 ? (
        <p className="text-sm text-muted-foreground italic">No activity yet.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b text-xs uppercase font-bold text-muted-foreground">
                <th className="text-left py-2 pr-4">When</th>
                <th className="text-left py-2 pr-4">Action</th>
                <th className="text-left py-2 pr-4">Admin</th>
                <th className="text-left py-2 pr-4">Collection</th>
                <th className="text-right py-2 pr-4">Rows</th>
                <th className="text-left py-2">Detail</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => {
                const action = row.action || 'export';
                const colorClass = ACTION_COLORS[action] || 'bg-slate-100 text-slate-800';
                return (
                  <tr key={row.id} className="border-b last:border-b-0 hover:bg-slate-50">
                    <td className="py-2 pr-4 tabular-nums">{formatTs(row.ts)}</td>
                    <td className="py-2 pr-4">
                      <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold uppercase ${colorClass}`}>
                        {action.replace('_', ' ')}
                      </span>
                    </td>
                    <td className="py-2 pr-4">{row.admin_email}</td>
                    <td className="py-2 pr-4 font-mono">{row.collection}</td>
                    <td className="py-2 pr-4 text-right tabular-nums">{row.row_count}</td>
                    <td className="py-2 text-xs text-muted-foreground">
                      {row.file_format || '—'}
                      {row.date_from || row.date_to
                        ? ` · ${row.date_from || '…'} → ${row.date_to || '…'}`
                        : ''}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
